const PARAGRAPH_CTA_BLOCK = (uuid: string, language: string) => `
  paragraphsDataUUID(uuid: "${uuid}", language: "${language}") {
     ... on BlocksSlideshow {
      id
      ctaBlocks {
        id
        blockBackground
        blurb
        ctaButtons {
          color
          title
          url
        }
        hideForUsers
        logo
        uuid
      }
      heading
      type
      uuid
      icon
    }
  }
`;

export default PARAGRAPH_CTA_BLOCK;
